module.exports = {
      id: "ic-commodity-channel-index-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-commodity-channel-index-usage",
      toString: function () {
        return this.url;
      }
    }